module.exports = __webpack_public_path__ + "img/data-screen-head.f71a2537.png";